import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../DatiSpecifici/DatiSpecifici.module.css";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import Input from "../../../../../components/textbox/Input";

class Parte3 extends Component {

    state = {
        parte3: {
            dataIngresso: "",
            trimestre: "",
            anno: ""
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloDati = this.controlloDati.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.validate = this.validate.bind(this);

    }

    componentDidMount() {
        let parte3 = this.state.parte3
        let parte3Copia = this.props.segnalazioneCopia.esitoTbcPolmonare && this.props.segnalazioneCopia.esitoTbcPolmonare.parte3 ?
            this.props.segnalazioneCopia.esitoTbcPolmonare.parte3 : ""
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.esitoTbcPolmonare && parte3Copia) {
            for (let key in parte3) {
                if (parte3.hasOwnProperty(key) === parte3Copia.hasOwnProperty(key)) {
                    if (key === "dataIngresso") {
                        parte3[key] = Utils.transformDateForFrontend(parte3Copia[key])
                    } else {
                        parte3[key] = parte3Copia[key]
                    }
                } else {
                    parte3[key] = ""
                }
            }
            this.setState({parte3: parte3})
        }
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloDati()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte3", oggettoBE, corretto)
    }

    riceviValore(field, event) {
        let parte3 = this.state.parte3
        parte3[field] = event.target.value
        this.setState({parte3: parte3})
        let corretto = this.controlloDati()
        let oggettoBE = this.createObjectBE()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte3", oggettoBE, corretto, this.validate())
    }

    validate() {
        if (this.state.parte3.dataIngresso && Utils.validateDate(this.state.parte3.dataIngresso, "Messages.DataIngresso", "Messages.DataIngressoOdierna")) {
            return Utils.validateDate(this.state.parte3.dataIngresso, "Messages.DataIngresso", "Messages.DataIngressoOdierna")
        }
        return ""
    }

    controlloDati() {
        let parte3 = this.state.parte3
        let corretto = []

        if(parte3.dataIngresso && Utils.isDateInValid(Utils.transformDateForBackend(parte3.dataIngresso), "-")) corretto[0] = "Campo \"Data ingresso follow-up di trattamento\" errato";

        return corretto
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.parte3))
        oggettoBE.dataIngresso = Utils.transformDateForBackend(oggettoBE.dataIngresso)
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    render() {

        const {t} = this.props

        const parte3 = (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("SchedaSpecialeTbcPolmonare.parte3")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-lg-3"}>
                            <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                                {t("SchedaSpecialeTbcPolmonare.dataIngresso")}
                            </p>
                        </div>
                        <div className={"col-lg-4"}>
                            <Calendar id={"dataIngresso"}
                                      value={this.state.parte3.dataIngresso}
                                      field={"dataIngresso"}
                                      onChange={this.riceviValore}
                                      newCalendar={true}
                                      errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                          t("SchedaSpecialeTbcPolmonare.dataIngresso"))}
                                      error={(!this.state.parte3.dataIngresso) ? false :
                                          Utils.isDateInValid(Utils.transformDateForBackend(this.state.parte3.dataIngresso), "-")}
                            />
                        </div>
                    </div>


                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-lg-3"}>
                            <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                                {t("SchedaSpecialeTbcPolmonare.trimestre")}
                            </p>
                        </div>
                        <div className={"col-lg-2"}>
                            <Input
                                id={"trimestre"}
                                onChange={this.riceviValore}
                                field={"trimestre"}
                                value={this.state.parte3.trimestre}
                                placeholder={t("SchedaSpecialeTbcPolmonare.trimestre")}
                            />
                        </div>
                    </div>

                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-lg-3"}>
                            <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                                {t("SchedaSpecialeTbcPolmonare.anno")}
                            </p>
                        </div>
                        <div className={"col-lg-2"}>
                            <Input
                                type={"number"}
                                min="0"
                                id={"anno"}
                                onChange={this.riceviValore}
                                field={"anno"}
                                value={this.state.parte3.anno}
                                placeholder={t("SchedaSpecialeTbcPolmonare.aaaa")}
                            />
                        </div>
                    </div>

                </div>
            </div>


        )

        return (
            <div>
                {parte3}
            </div>
        );
    }

}

export default withTranslation('common')(Parte3)
